import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../../Frames/Layout";
import { useEffect, useState } from "react";
import DPC from '../../../../services/API/DPC';
import { Alert, TextField, Stack, CircularProgress } from "@mui/material";
import FormButtons from "../../../Inputs/FormButtons";
import Select from "../../../Inputs/Select";
import CourseSelect  from "../../../Inputs/CourseSelect";
import Number from "../../../Inputs/Number";
import Toggle from "../../../Inputs/Toggle";
import useOptimisticUpdate from '../../../../services/ReactQuery/useOptimisticUpdate';

export default function Form(){

    const navigate = useNavigate();

    const {id} = useParams();
    const isNew = id === 'new';

    const mutation = useOptimisticUpdate('dpc_actions', () => null)

    const [item, setItem] = useState(null)
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)
    const [productCode, setProductCode] = useState(!isNew)

    useEffect(() => {

        if(isNew){
            setItem(defaultAction)
        }else{
            DPC.getAction(id)
                .then(r => setItem(r.data))
                .catch(e => console.log(e))
        }

    }, [id, isNew])
    
 
    const handleSubmit = e => {
        e.preventDefault();

        (isNew ? DPC.postAction(item) : DPC.putAction(item))
            .then(r => handleSuccess(r))
            .catch(e => handleError(e))

        return setLoading(true);
    }

    const handleSuccess = r => {
        console.log(r.data);
        mutation.mutate(item);
        return navigate(-1);
    }

    const handleError = e => {
        console.log(e.response?.data);

        let message = e.response?.status === 409 ?
            `L'identifiant ${item.id} est déjà utilisé.`
            : `Une erreur s'est produite, les données n'ont pas pu être enregistrées.`;

        setLoading(false);
        return setError(message);
    }


    return <Layout tab='actions' menu='dpc' title='Action DPC' back>

        <Stack direction='row' justifyContent='center'>

            {item && <form onSubmit={handleSubmit}>

                <Stack direction='column' width={formWidth} spacing={3}>

                    {error && <Alert severity='error'>{error}</Alert>}

                    <TextField
                        label='Référence'
                        type='number'
                        required
                        value={item.id}
                        onChange={e => setItem({...item, id: e.target.value})}
                        inputProps={{min: 1, step: 1}}
                        size='small'
                        disabled={!isNew}
                    />

                    <TextField
                        label="Nom de l'action"
                        required
                        value={item.title}
                        onChange={e => setItem({...item, title: e.target.value})}
                        inputProps={{maxLength: 255}}
                        size='small'
                    />

                    <Select
                        label="Type d'action"
                        required
                        value={item.type.id}
                        onChange={e => setItem({...item, 
                            type: actionTypes.find(t => t.id === e.target.value),
                            epp1OfflineDuration: e.target.value === 'pi' ? 0 : item.epp1OfflineDuration,
                            epp2OfflineDuration: e.target.value === 'pi' ? 0 : item.epp2OfflineDuration,
                            epp1OnlineDuration: e.target.value === 'pi' ? 0 : item.epp1OnlineDuration,
                            epp2OnlineDuration: e.target.value === 'pi' ? 0 : item.epp2OnlineDuration,
                        })}
                        options={actionTypes}
                    />

                    <TextField
                        label="Orientation(s)"
                        required
                        value={item.theme}
                        onChange={e => setItem({...item, theme: e.target.value})}
                        inputProps={{maxLength: 500}}
                        size='small'
                        multiline
                        maxRows={10}
                    />

                    <TextField
                        label='Année'
                        type='number'
                        value={item.year}
                        onChange={e => setItem({...item, year: e.target.value})}
                        inputProps={{step: 1}}
                        required
                        size='small'
                    />

                    {!productCode && <CourseSelect
                        value={item.course.id}
                        onChange={courseId => setItem({...item, course: {id: courseId}})}
                        required
                        disabled={!isNew}
                    />}

                    {productCode && <TextField
                        label="Code produit"
                        required
                        value={item.course?.id || ''}
                        onChange={e => setItem({...item, 
                            course: {id: e.target.value.replaceAll(' ','')}
                        })}
                        inputProps={{maxLength: 30}}
                        size='small'
                        disabled={!isNew}
                    />}

                    {isNew && <Toggle 
                        label="Saisir directement le code produit" 
                        value={productCode}
                        onChange={() => setProductCode(!productCode)}
                    />}

                    <Number
                        label='Durée (en heures)'
                        value={item.duration}
                        onChange={e => setItem({...item, duration: e.target.value})}
                        min={1}
                        step={1}
                        unit='h'
                        required
                    />

                    {item.type.id === 'pi' && <>
                        <Number
                            label='Heure.s NON connectées EPP1'
                            value={item.epp1OfflineDuration}
                            onChange={e => setItem({...item, epp1OfflineDuration: e.target.value})}
                            min={1}
                            step={1}
                            unit='h'
                            required
                        />

                        <Number
                            label='Heure.s NON connectées EPP2'
                            value={item.epp2OfflineDuration}
                            onChange={e => setItem({...item, epp2OfflineDuration: e.target.value})}
                            min={1}
                            step={1}
                            unit='h'
                            required
                        />

                        <Number
                            label='Heure.s connectées EPP1'
                            value={item.epp1OnlineDuration}
                            onChange={e => setItem({...item, epp1OnlineDuration: e.target.value})}
                            min={1}
                            step={1}
                            unit='h'
                            required
                        />

                        <Number
                            label='Heure.s connectées EPP2'
                            value={item.epp2OnlineDuration}
                            onChange={e => setItem({...item, epp2OnlineDuration: e.target.value})}
                            min={1}
                            step={1}
                            unit='h'
                            required
                        />
                    </>}

                                        <Toggle 
                                            label="Classe virtuelle"
                                            value={item.live ? true : false}
                                            onChange={e => setItem({...item, live: 
                                                (item.live ? null : {
                                                    name: '',
                                                    duration: 120,
                                                    teacherLastName: '',
                                                    teacherFirstName: '',
                                                    teacherRpps: '',
                                                })
                                            })}
                                        />
                    
                                        {item.live && <>
                    
                                            <TextField
                                                label="Nom de la classe virtuelle"
                                                value={item.live.name || ''}
                                                onChange={e => setItem({...item, live: 
                                                    {...item.live, name: e.target.value}
                                                })}
                                                size='small'
                                            />
                    
                                            <TextField
                                                label="Durée de la classe virtuelle (en minutes)"
                                                type='number'
                                                value={item.live.duration || ''}
                                                onChange={e => setItem({...item, live: 
                                                    {...item.live, duration: parseInt(e.target.value)}
                                                })}
                                                size='small'
                                            />
                    
                                            <TextField
                                                label="Nom de l'intervenant de la classe virtuelle"
                                                value={item.live.teacherLastName || ''}
                                                onChange={e => setItem({...item, live: 
                                                    {...item.live, teacherLastName: e.target.value}
                                                })}
                                                size='small'
                                            />
                    
                                            <TextField
                                                label="Prénom de l'intervenant de la classe virtuelle"
                                                value={item.live.teacherFirstName || ''}
                                                onChange={e => setItem({...item, live: 
                                                    {...item.live, teacherFirstName: e.target.value}
                                                })}
                                                size='small'
                                            />
                    
                                            <TextField
                                                label="RPPS de l'intervenant de la classe virtuelle"
                                                value={item.live.teacherRpps || ''}
                                                onChange={e => setItem({...item, live: 
                                                    {...item.live, teacherRpps: e.target.value}
                                                })}
                                                size='small'
                                            />
                    
                                        </>}

                    <FormButtons onCancel={() => navigate(-1)} loading={loading}/>

                </Stack>

            </form>}

            {!item && <CircularProgress size={30}/>}

        </Stack>

    </Layout>
}

const formWidth = window.screen.width < 800 ? 350 : 600;

const actionTypes = [
    {id: 'fc', title: 'Formation continue', value: 'fc'},
    {id: 'pi', title: 'Programme intégré', value: 'pi'},
]

const defaultAction = {
    id: '',
    title: '',
    theme: '',
    price: 0,
    duration: '',
    year: new Date().getFullYear(),
    type: actionTypes[0],
    course: {id: null},
    epp1OfflineDuration: 0,
    epp2OfflineDuration: 0,
    epp1OnlineDuration: 0,
    epp2OnlineDuration: 0,
    live: null,
};